import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';
import template from './action-panel-edit-apply-column.pug';

export class ActionPanelEditApply extends ProjectionGridBaseColumn {
  constructor({
    i18n, readOnly, deps, recommendationType,
  }) {
    super({
      name: 'Action',
      property: 'Recommendation/ActionPanelEditApply',
      title: i18n.getString('ColumnName_Action') || 'Action',
      bodyClasses: ['inline-action-panel-edit-apply-column'],
      colClasses: ['col-applyPanelEdit'],
    });
    this.i18n = i18n;
    this.readOnly = readOnly;
    this.deps = deps;
    this.recommendationType = recommendationType;
  }

  template() {
    const {
      i18n, readOnly, deps, recommendationType,
    } = this;
    const isPanelEdit = deps.permissions.IsRecommendationRSAMMAPnaelEditEnabled ||
    recommendationType === RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS ||
    recommendationType === RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL;
    return template({ i18n, readOnly, isPanelEdit });
  }
}
